import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import CateringOptionsList from 'components/CateringOptionsList';

import { withData } from 'lib';
import { SettingsCateringListPageQuery } from '__generated__/SettingsCateringListPageQuery.graphql';

const query = graphql`
  query SettingsCateringListPageQuery {
    ...CateringOptionsList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCateringListPageQuery>;
};

const SettingsCateringListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsCateringListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Maitinimas' },
      ]}>
      <CateringOptionsList data={data} />
    </Page>
  );
};

export default withData<SettingsCateringListPageQuery>({
  query,
})(SettingsCateringListPage);
